<template>
  <div class="bj-section">
    <div class="ubold-title" style="margin-bottom: 40px">登录日志</div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">登录时间：</div>
          <DatePicker
            class="bj-bg-color-26262A date-time-h45"
            v-model="startAtStr"
            format="yyyy-MM-dd"
            type="daterange"
            placeholder="请选择登录时间"
            style="width: 200px"
            @on-change="onTimeChange"
          ></DatePicker>
        </div>
        <div class="item" style="margin-left: 20px;">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px;"
            @click="onSearch"
            >搜索</Button
          >
          <Button
            class="bj-border-F85A36"
            @click="onSearchCancel"
            style="margin-right: 20px"
            >重置</Button
          >
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <div class="total">搜索结果<span class="count">（{{ total }}）</span></div>
      <Table
        class="bj-2F3033-table"
        stripe
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="verifyStatus" slot-scope="{ row }">
          <div>
            {{ row.verifyStatus | status }}
          </div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          class="pages"
          :current="page"
          :total="total"
          :page-size="limit"
          show-total
          show-sizer
          show-elevator
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { loginLogList } from "api/user.js";

export default {
  name: "myEmail",
  data() {
    return {
      startAtStr: "",
      startAt: "",
      endAt: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "序号",
          align: "center",
          type: "index",
        },
        {
          title: "登录时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "登录IP",
          align: "center",
          key: "ip",
          render: (h, { row }) => {
            return h("div", `${row.ip}-${row.address}`);
          },
        },
      ],
      data: [],
      tableLoading: false,
      addEmailModalVisibility: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        let params = {
          start: this.startAt,
          end: this.endAt,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await loginLogList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.endAt = "";
      this.startAt = "";
      this.startAtStr = "";
      this.onPageChange(1);
    },
    onTimeChange(val) {
      this.endAt = val[1];
      this.startAt = val[0];
    },
  },
};
</script>
<style lang="less" scoped>
.bj-search-section{
    background-color: #28292C;
    padding: 14px 28px;
    border-radius: 6px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
</style>
